export default "//qa-static.glanacion.com/v2/ingresar-nuevo/images/email-ok.png";